import { useContext } from 'react';

import { RichTextWithDocsMappingContext } from '../contexts/richTextWithDocsMappingContext';

export const useRichTextWithDocsMappingContext = () => useContext(RichTextWithDocsMappingContext);
